import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CTA from "@/components/CTA";
import mascotImage from "@/assets/coblynau-mascot.png";

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main-content" className="pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-foreground mb-8 text-center">About Coblynau IT Solutions</h1>
            <div className="flex justify-center mb-8">
              <img src={mascotImage} alt="Coblynau mascot" className="w-64 h-64 object-contain" />
            </div>
            <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
              <p>Based in beautiful Swansea, <strong className="text-foreground">Coblynau IT Solutions</strong> (pronounced "cob-LIN-eye") provides trusted IT support and services to businesses across South Wales.</p>
              <h2 className="text-2xl font-bold text-foreground mt-8">Our Name & Story</h2>
              <p>In Welsh folklore, the <em>Coblynau</em> are friendly, gnome-like creatures who dwelt in mines and quarries. They were known for guiding miners to rich ore deposits by tapping on the walls—always helpful, sometimes mischievous, but ultimately on the side of those they served.</p>
              <p>We chose this name because it perfectly captures our mission: to guide your business through the complex world of technology, helping you find the solutions that will drive your success.</p>
              <h2 className="text-2xl font-bold text-foreground mt-8">Why Choose Us?</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Local Swansea team with rapid response times</li>
                <li>Plain-English explanations—no confusing jargon</li>
                <li>Microsoft Partner with certified technicians</li>
                <li>Proactive monitoring to prevent issues before they occur</li>
                <li>Flexible packages tailored to your business needs</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-16"><CTA /></div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
